import { Pipe, PipeTransform } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';

@Pipe({
  name: 'showRelayOutputSelector'
})
export class ShowRelayOutputSelectorPipe implements PipeTransform {

  transform(controllers: Controller[], relayOutputNo): boolean {

    const byRentedprops = [];
    const forcedOnProps = [];
    const forcedOffProps = [];
    const autoModeProps = [];

      controllers.forEach((cont)=> {
        cont.controllerProperties.$values.forEach((prop)=> {
          if (prop.mqttTopic.split('/')[3] !== relayOutputNo.toString()) {
            return
          }
          if (Property.isRelayOutputByRentedOrPresence(prop)) {
            byRentedprops.push(prop)
          } else if (Property.isRelayOutputForceOn(prop)) {
            forcedOnProps.push(prop)
          } else if (Property.isRelayOutputForceOff(prop)) {
            forcedOffProps.push(prop)
          }else if (Property.isRelayOutputAutoMode(prop)) {
            autoModeProps.push(prop)
          }
        })
      })



if (atLeastTwoNonEmpty(byRentedprops, forcedOnProps, forcedOffProps, autoModeProps)) {
  return true
} else {
  return false
}

    function atLeastTwoNonEmpty(...arrays) {
      let nonEmpty = 0;
      for (const arr of arrays) {
        if (Array.isArray(arr) && arr.length > 0) {
          nonEmpty++;
          if (nonEmpty >= 2) return true;
        }
      }
      return false;
    }
  }

}
